import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { RequestStockPhraseDto } from "../models/orders/requestStockPhraseDto";
import { StockPhrase } from "../models/orders/stockPhrase";

@Injectable({
  providedIn: "root",
})
export class StockPhrasesService {
  private stockPhraseBaseURL = environment.baseUrl + "/StockPhrase";
  constructor(private _http: HttpClient) {}

  createStockPhrase(
    payload: StockPhrase
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.stockPhraseBaseURL + "/CreateStockPhrase",
      payload
    );
  }

  deleteStockPhrase(
    payload: number[]
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.stockPhraseBaseURL + "/DeleteStockPhrase",
      payload
    );
  }

  getStockPhrase(payload: RequestStockPhraseDto): Observable<StockPhrase[]> {
    return this._http.post<StockPhrase[]>(
      this.stockPhraseBaseURL + "/GetStockPhrases",
      payload
    );
  }
}
